module.exports = __webpack_public_path__ + "img/img19.0542a6a6.png";